import BookingConfirmationContainer from './BookingConfirmationContainer'

export default BookingConfirmationContainer
